import { Signal } from '@angular/core';
import { recordfromRecord, recordSet } from './record.function';
import { StoreDataClasses } from '../storage/data-store/data-store-classes.type';

// export const updateObjectInMap = <T extends StoreDataClasses>(
//   id: string,
//   obj: Partial<T>,
//   animalweighings: Signal<Record<string, T>>
// ) => {
//   const editableRecord = recordfromRecord(animalweighings());

//   const existingObj = recordAttemptGet(editableRecord, id);
//   if (existingObj === undefined) {
//     throw new Error(
//       `updateObjectInMap: Object with id ${id} not found in the map. update object ${JSON.stringify(obj)}`
//     );
//   }
//   const modifiedObj = { ...existingObj, ...obj } as T;
//   recordSet(editableRecord, id, modifiedObj);
//   return editableRecord;
// };

// export const upsertPartialToMap = <T extends StoreDataClasses>(
//   id: string,
//   obj: Partial<T>,
//   animalweighings: Signal<Record<string, T>>
// ) => {
//   const editableMap = recordfromRecord(animalweighings());

//   const existingObj = recordGet(editableMap, id);
//   const modifiedObj = { ...existingObj, ...obj } as T;
//   recordSet(editableMap, id, modifiedObj);
//   return editableMap;
// };

export const updateAllObjectsInMap = <T extends StoreDataClasses>(
  obj: Partial<T>[],
  dataFromStore: Signal<Record<string, T>>
) => {
  const editableRecord = recordfromRecord(dataFromStore());

  obj.forEach((value) => {
    const key = value.id;
    if (key === undefined) {
      throw new Error(
        `updateAllObjectsInMap: Object with id ${key} not found in the map. update object ${JSON.stringify(value)}`
      );
    }
    const existingObj = editableRecord[key];
    if (existingObj === undefined) {
      throw new Error(
        `updateAllObjectsInMap: Object with id ${key} not found in the map. update object ${JSON.stringify(value)}`
      );
    }
    const modifiedObj = { ...existingObj, ...value } as T;
    recordSet(editableRecord, key, modifiedObj);
  });
  return editableRecord;
};
